import "./App.css";
import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

import HomePage from "./Pages/HomePage.jsx";
import Navbar from "./functional-components/Navbar.jsx";
import Footer from "./functional-components/Footer.jsx";
import { PageLayout } from "./functional-components/PageLayout.jsx";
// import { useMsal } from "@azure/msal-react";
// import { MsalProvider } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import ChooseClusterPage from "./Pages/ChooseClusterPage.jsx";
import CapabilitiesPage from "./Pages/CapabilitiesPage.jsx";
import CalendarPage from "./Pages/CalendarPage.jsx";
import FAQPage from "./Pages/FAQPage.jsx";

function App({ pca }) {
  return (
    <PageLayout>
      <div container justifyContent="center">
        <Pages />
      </div>
    </PageLayout>
  );
}

function Pages() {
  // const { instance } = useMsal();
  // const activeAccount = instance.getActiveAccount();
  // useEffect(() => {
  //   console.log("activeAccount", activeAccount);
  //   if (activeAccount) {
  //     fetchAccessToken();
  //   }
  // }, [activeAccount, instance]);
  // const fetchAccessToken = async () => {
  //   if (!activeAccount)
  //     throw Error(
  //       "No active account! Verify a user has been signed in and setActiveAccount has been called.",
  //     );
  //   try {
  //     const response = await instance.acquireTokenSilent({
  //       ...loginRequest,
  //       account: activeAccount,
  //     });
  //     const bearer = `Bearer ${response.accessToken}`;
  //     localStorage.setItem("token", bearer);
  //     console.log("bearer", bearer);
  //   } catch (error) {
  //     console.error("Error fetching access token:", error);
  //     localStorage.clear();
  //   }
  // };
  return (
    <>
      <Navbar />

      <main className="contents">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/choose-cluster" element={<ChooseClusterPage />} />
          <Route path="/capabilities" element={<CapabilitiesPage />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/faq" element={<FAQPage />} />
        </Routes>
      </main>

      <Footer />
    </>
  );
}

export default App;
